var _rect, _circle, _circle2, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRetail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 250",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#2D3436",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#636E72",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "accentGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#FF7675",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#FD79A8",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 250,
    fill: "url(#bgGradient)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 80,
    fill: "url(#accentGradient)",
    opacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 200,
    r: 100,
    fill: "url(#accentGradient)",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, 125)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF",
    fontFamily: "Arial Black, sans-serif",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontSize: 45,
    letterSpacing: 5
  }, "\n        RETAIL\n      ")), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 20,
    width: 240,
    height: 4,
    fill: "url(#accentGradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: -40,
    width: 160,
    height: 2,
    fill: "#FFFFFF",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF",
    fontFamily: "Arial Black, sans-serif",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 50,
    fontSize: 15,
    letterSpacing: 3
  }, "\n        Refonte logicielle\n      "), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 70,
    fontSize: 15,
    letterSpacing: 3
  }, "\n        SIRH\n      ")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(300, 50)",
    fill: "#FFFFFF",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,0 L40,30 H0 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 45,
    r: 5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(300, 200)",
    fill: "#FFFFFF",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 0,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 0,
    width: 15,
    height: 15
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetail);
export default __webpack_public_path__ + "static/media/retail.c7f01f4524ca80685aa30f25d70f2108.svg";
export { ForwardRef as ReactComponent };